import { Outlet, NavLink } from 'react-router-dom'
import MyIcon from '../../components/general/icon'

export default function Nav() {
    const computedClassName = ({ isActive }) => { return isActive ? "main-nav-menu main-nav-menuActive" : "main-nav-menu" }

    return (
        <div className="main-nav-page">
            <div className="main-nav-container">
                <div className="main-nav-box">
                    <div className="main-nav-title">企业入驻</div>
                    <NavLink to="enterprise_entry" className={computedClassName}>
                        <div className="main-nav-icon"><MyIcon name='ruku' /></div>
                        <div className="main-nav-name">入驻申请</div>
                        <div className="main-nav-number"></div>
                    </NavLink>
                </div>
                <div className="main-nav-box">
                    <div className="main-nav-title">宣讲会</div>
                    <NavLink to="presentation_venue" className={computedClassName}>
                        <div className="main-nav-icon"><MyIcon name='dianpu' /></div>
                        <div className="main-nav-name">场地管理</div>
                        <div className="main-nav-number"></div>
                    </NavLink>
                    <NavLink to="presentation_slot" className={computedClassName}>
                        <div className="main-nav-icon"><MyIcon name='shoujibiaodan' /></div>
                        <div className="main-nav-name">资源管理</div>
                        <div className="main-nav-number"></div>
                    </NavLink>
                    <NavLink to="presentation_application" className={computedClassName}>
                        <div className="main-nav-icon"><MyIcon name='yanqi' /></div>
                        <div className="main-nav-name">预约申请</div>
                        <div className="main-nav-number"></div>
                    </NavLink>
                </div>
                <div className="main-nav-box">
                    <div className="main-nav-title">双选会</div>
                    <NavLink to="job_fair_venue" className={computedClassName}>
                        <div className="main-nav-icon"><MyIcon name='dianpu' /></div>
                        <div className="main-nav-name">展位管理</div>
                        <div className="main-nav-number"></div>
                    </NavLink>
                    <NavLink to="job_fair_slot" className={computedClassName}>
                        <div className="main-nav-icon"><MyIcon name='shoujibiaodan' /></div>
                        <div className="main-nav-name">资源管理</div>
                        <div className="main-nav-number"></div>
                    </NavLink>
                    <NavLink to="job_fair_application" className={computedClassName}>
                        <div className="main-nav-icon"><MyIcon name='yanqi' /></div>
                        <div className="main-nav-name">预约申请</div>
                        <div className="main-nav-number"></div>
                    </NavLink>
                </div>
                <div className="main-nav-box">
                    <div className="main-nav-title">设置</div>
                    <NavLink to="event_config" className={computedClassName}>
                        <div className="main-nav-icon"><MyIcon name='peizhixinxi' /></div>
                        <div className="main-nav-name">配置信息</div>
                        <div className="main-nav-number"></div>
                    </NavLink>
                </div>
            </div>
            <Outlet />
        </div>
    )
}
